import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import CaptchaGenStatEditService from 'app/admin/captchagenstat/service/CaptchaGenStatEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import CaptchaTypeEditService from '../../captchatype/service/CaptchaTypeEditService';

const config = {
	key: 'captchaGenStatEditForm',
	text: 'Captcha To Generate',
	textKey: 'captchaGenStat',
	service: CaptchaGenStatEditService,
	icon: 'person',
	fields: [
		{
			key: 'profileNames',
			text: 'Profile Names',
			textKey: 'profileNames',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'captchaTypeEngineName',
			text: 'Captcha Type Engine Name',
			textKey: 'captchaTypeEngineName',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'captchaTypeEngineParams',
			text: 'Captcha Type Engine Params',
			textKey: 'captchaTypeEngineParams',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'numberOfGenerated',
			text: 'Number Of Generated',
			textKey: 'numberOfGenerated',
			component: EditFormTextField,
			required: true,
			type: 'number'
		},
		{
			key: 'minimumGenerationTime',
			text: 'Minimum Generation Time',
			textKey: 'minimumGenerationTime',
			component: EditFormTextField,
			required: true,
			type: 'number'
		},
		{
			key: 'averageGenerationTime',
			text: 'Average Generation Time',
			textKey: 'averageGenerationTime',
			component: EditFormTextField,
			required: true,
			type: 'number'
		},
		{
			key: 'maximumGenerationTime',
			text: 'Maximum Generation Time',
			textKey: 'maximumGenerationTime',
			component: EditFormTextField,
			required: true,
			type: 'number'
		}
	]
};

function CaptchaGenStatEditForm() {
	return <EditFormPage config={config} />;
}

export default CaptchaGenStatEditForm;
